// extracted by mini-css-extract-plugin
module.exports = {"surveyTitle":"_10CvjwfLcf-xd7l2","errorText":"_2eotlZxHJK3YanMM","floatingLabel":"DnSGdkq42T6hD7LV","error":"_22OdUCpbYpuRX06h"};